"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Modal/index"), exports);
var index_1 = require("./components/Modal/index");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return index_1.Modal; } });
//# sourceMappingURL=Modal.js.map